import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { notification } from 'antd'
import { INetworkError } from 'interfaces'
import { useEffect } from 'react'

export function useHandleErrors(error: FetchBaseQueryError | SerializedError | undefined) {
  useEffect(() => {
    if (error && 'data' in error) {
      notification.error({
        message: (error.data as INetworkError).code || 'Network Error',
        description: (error.data as INetworkError).message || 'Something went wrong',
      })
    }
  }, [error])
  return error
}
